/* header-offset.js – calcula altura del header-group y ajusta el MainContent */
(() => {
  const MAIN_SELECTOR = '#MainContent';
  // intentamos varios posibles contenedores del header-group
  const GROUP_SELECTOR_PRIMARY = 'header-wrapper.header__outer';
  const GROUP_SELECTOR_FALLBACK = '.shopify-section-group-header-group';

  const debounce = (fn, wait = 80) => {
    let t;
    return (...a) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...a), wait);
    };
  };

  const getGroup = () =>
    document.querySelector(GROUP_SELECTOR_PRIMARY) ||
    document.querySelector(GROUP_SELECTOR_FALLBACK) ||
    document.getElementById('shopify-section-header');

  const measureHeight = (el) =>
    el ? Math.round(el.getBoundingClientRect().height) : 0;

  const applyOffset = () => {
    const main = document.querySelector(MAIN_SELECTOR);
    const group = getGroup();
    if (!main || !group) return;

    const h = measureHeight(group);
    document.documentElement.style.setProperty(
      '--total-header-height',
      h + 'px'
    );
    main.style.paddingTop = h + 'px';
  };

  const recalc = debounce(applyOffset, 80);

  function init() {
    recalc();

    // Resize
    window.addEventListener('resize', recalc, { passive: true });

    // Cuando cargan fuentes
    if (document.fonts?.ready) {
      document.fonts.ready.then(recalc).catch(() => {});
    }

    // Recalcos tardíos por si announcement / barras aparecen después
    setTimeout(recalc, 250);
    setTimeout(recalc, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // API manual por si alguna vez lo necesitas
  window.addEventListener('sepiia:header:recalc', recalc);
})();
